if (!customElements.get('page-slider-component')) {
  customElements.define('page-slider-component', class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        arrows: this.querySelectorAll('[data-dir]'),
        children: this.querySelector('[data-slider-container] > *:not(script)'),
        container: this.querySelector('[data-slider-container]')
      }

      for (let i = 0; i < this.elements.arrows.length; i++) {
        this.elements.arrows[i].addEventListener('click', this.scrollContainer.bind(this));
      }
    }

    scrollContainer(e) {
      var target = e.target;
      var direction = target.getAttribute('data-dir') === 'left' ? 'left' : 'right';
      var scrollAmount = this.elements.children.clientWidth;

      if (direction === 'left') {
        this.elements.container.scrollLeft -= scrollAmount + 30;
      } else {
        this.elements.container.scrollLeft += scrollAmount + 30;
      }
    }
  });
}